import {
  fallback,
  zodValidator,
} from '@tanstack/zod-adapter';
import {
  z,
} from 'zod';

export const sessionTokenSearchSchema = z.object({
  state: fallback(z.string(), ''),
  session_state: fallback(z.string(), ''),
  code: fallback(z.string(), ''),
});

export type SessionTokenSearch = z.infer<typeof sessionTokenSearchSchema>;
export const sessionTokenValidator = zodValidator(sessionTokenSearchSchema);

export default sessionTokenValidator;
